import { createSelector } from 'reselect';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
const getHeader = basicSelector(state => state.header);
export const getHeaderActiveItem = createSelector([getHeader], header => header.activeItem);
export const getShouldClearHeaderActiveItem = createSelector([getHeader], header => header.shouldClear);
export const getShowSwapHeaderModal = createSelector([getHeader], header => header.showSwapHeaderModal);